module.exports = __webpack_public_path__ + "static/media/partner_aiqiyi.977c9545.png";